import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import "./hero.scss";

import logo_rbr from "images/bi/logo_rbr.png";
import logo_rabarbaro from "images/bi/logo_rabarbaro.png";
import logo_rabar from "images/bi/logo_rabar.png";
import video from "video/rabarbaro_avvio-orizzontale.mp4";

import { heroCarousel } from "site-structure";

const Entry = () => {
	return (
		<>
			<section className="home-section home-full-height" id="home">
				<div className="hero-slider">
					<div className="slides">
						<div className="item">
							<div
								className="bg-dark-30 restaurant-page-header restaurant-entry bg-dark"
								style={{
									height: "100vh",
								}}>
								<video
									autoPlay
									loop
									muted
									height={"100vh"}
									width={"100%"}
									playsInline
									style={{
										position: "absolute",
										height: "100%",
										objectFit: "cover",
										zIndex: 0,
										left: 0,
										right: 0,
										top: 0,
										left: 0,
									}}>
									<source src={video} type="video/mp4" />
									Your browser does not support the video tag.
								</video>

								<div className="fake-pseudo">
									<div class="container">
										<div class="row mb-3">
											<div class="col">
												<div class="text-center logo-rbr">
													<img src={logo_rbr} />
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-6">
												<div className="content-box">
													<div className="titan-caption">
														<div className="caption-content">
															<div className="font-alt mb-20 titan-title-size-1">
																{" "}
																Lavanderia di cucina gagliarda
															</div>
															<div className="font-alt mb-20 logo-hero">
																<img src={logo_rabarbaro} />
															</div>
															<Link
																className="section-scroll btn btn-theme btn-round mb-10"
																target="_blank"
																rel="noreferrer"
																to={heroCarousel[0].action}>
																Prenota un tavolo da Rabarbaro
															</Link>
															<br />
															<Link
																className="section-scroll btn btn-border-w btn-round"
																rel="noreferrer"
																to="/rabarbaro">
																Scopri di più
															</Link>
														</div>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div className="content-box">
													<div className="titan-caption">
														<div className="caption-content">
															<div className="font-alt mb-20 titan-title-size-1">
																{" "}
																Fioreria di colazioni e aperitivi
															</div>
															<div className="font-alt mb-20 logo-hero">
																<img src={logo_rabar} />
															</div>
															<Link
																className="section-scroll btn btn-theme btn-round mb-10"
																target="_blank"
																rel="noreferrer"
																to="https://api.whatsapp.com/send?phone=3335468741&text=Ciao,vorrei%20prenotare%20un%20tavolo%20da%20Rabar.">
																Prenota un tavolo da Rabar
															</Link>
															<br />
															<Link
																className="section-scroll btn btn-border-w btn-round"
																rel="noreferrer"
																to="/rabar">
																Scopri di più
															</Link>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Entry;
